// extracted by mini-css-extract-plugin
module.exports = {"container--breakout":"AdaptiveGallery_container--breakout__rIhuM","containerBreakout":"AdaptiveGallery_container--breakout__rIhuM"};